export default __webpack_public_path__ + "static/media/background-mapa.49369417.svg";